import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../../utilities/props.js";
import s from "./Button.module.css";
const ButtonGroup = (props) => {
    const { children, className, attributes } = props;
    const groupClassNames = classNames(s.group, className);
    return (_jsx("div", { ...attributes, className: groupClassNames, role: "group", children: children }));
};
ButtonGroup.displayName = "Button.Group";
export default ButtonGroup;
